import "./styles.less";

import React from "react";
import { useFavorite } from "./hook";
import { useUser } from "shared-components/Components/User/User.hook";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { HeartIcon } from "shared-components/Components/CustomIcons/HeartIcon/web";
import { Button } from "shared-components/Components/Buttons/web";

export function Favorite({
	id,
	type = "default",
	isEspecial,
	isDisabledProperty = false,
}: {
	id: any;
	type?: "default" | "justIcon";
	isEspecial?: Boolean;
	isDisabledProperty?: boolean;
}) {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { isFavorite, toggleFavorite, mutationLoading, loading } = useFavorite({ id });
	const {
		user: { data },
	} = useUser();
	// const GA = useGoogleAnalytics();

	const successMessage = async (e) => {
		const added = e.data.toggleFavorite.favorites.find(e => e.property_id == id);
		// GA.Event({
		// 	category: 'user_event',
		// 	action: 'favorite_btn',
		// 	label: added ? 'added' : 'removed'
		// })
		if (added) {
			handleClickShowNotification({
				message: "Propiedad agregada a favoritos",
				description: "Te avisaremos automáticamente cuando cambie de precio o se actualice su estado.",
			});
		} else {
			handleClickShowNotification({
				message: "Propiedad eliminada de favoritos",
				description: "No recibirás avisos automáticos de la propiedad.",
			});
		}
	};

	// Valido si muestro el error solo si el usuario esta logeado ya que
	// Solo puede ser favorito cuando hay usuario en sesion.
	const errorMessage = async () => {
		if (data && data.me) {
			handleClickShowNotification({
				message: "Error en favoritos",
				description: "Hubo un error. Vuelva a intentarlo.",
				type: "error",
			});
		}
	};

	return <Button type={type == 'justIcon' ? 'noStyles' : 'secondary'}
		disabled={loading || isDisabledProperty}
		className={`favorite-button ${type}`}
		onClick={e => {
			e.preventDefault()
			e.stopPropagation()
			toggleFavorite()
				.then(successMessage)
				.catch(errorMessage)
		}}
	>
		<HeartIcon fillOpacity={isFavorite ? 0.8 : 0.4} strokeColor="#fff" fillColor={isFavorite ? "#fc7b27" : "black"} />
		{!isEspecial
			? type !== "justIcon"
				? isFavorite
					? "Guardado"
					: "Guardar"
				: null
			: null}
	</Button>

}
